export const getStatusName = (row) => {
	if (row.size === row.messagesSentCount) return "Sent";
	switch (row.status) {
		case 0:
			return "Draft";
		case 1:
			return "Scheduled";
		case 2:
			return "Sending";
		case 3:
			return "Sent";
		default:
			return "Unknown";
	}
};
